/**
 * Convert notes in various formats to tiptap JSON format
 * @param notes - Can be an array of strings, a string, or already a tiptap doc
 * @returns Tiptap JSON structure or null if no notes provided
 */
export const plainTextToTiptap = (notes: any): any | null => {
  if (!notes) return null;

  // Handle different note formats
  let noteLines: string[] = [];

  if (Array.isArray(notes)) {
    noteLines = notes;
  } else if (typeof notes === "string") {
    noteLines = notes.split("\n");
  } else if (typeof notes === "object" && notes.type === "doc") {
    // Already in tiptap format
    return notes;
  } else {
    return null;
  }

  // Convert to tiptap format
  return {
    type: "doc",
    content: noteLines.map((line) => ({
      type: "paragraph",
      content: line.trim() ? [{ type: "text", text: line }] : [],
    })),
  };
};
